
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ButtonColorful } from "@/components/ui/button-colorful";
import { Trash, Copy } from "lucide-react";
import { redirectToEditor } from "@/utils/redirectToEditor";

interface ProgramActionsProps {
  onDeleteClick?: () => void;
  onDuplicateClick?: () => void;
  isDuplicating?: boolean;
}

export function ProgramActions({ 
  onDeleteClick, 
  onDuplicateClick,
  isDuplicating = false 
}: ProgramActionsProps) {
  const { id } = useParams();

  const handleEditProgram = () => {
    if (id) {
      redirectToEditor(id);
    }
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <ButtonColorful 
        label="Edit Program"
        onClick={handleEditProgram}
      />
      
      <div className="flex space-x-3">
        {onDuplicateClick && (
          <Button
            variant="outline"
            onClick={onDuplicateClick}
            disabled={isDuplicating}
          >
            <Copy className="mr-2 h-4 w-4" />
            {isDuplicating ? 'Duplicating...' : 'Duplicate'}
          </Button>
        )}
        
        {onDeleteClick && (
          <Button
            variant="destructive"
            onClick={onDeleteClick}
          >
            <Trash className="mr-2 h-4 w-4" />
            Delete
          </Button>
        )}
      </div>
    </div>
  );
}
